import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";
import { toast } from "react-toastify";

export const approveExistingEmp = createAsyncThunk(
  "approveExistingEmp/approveExistingEmp",
  async (payload, { rejectWithValue }) => {
    try {
      const url = `${api.approveExistingEmp}`;
      const response = await axiosPrivate.post(url, payload);
      if (response.data.success === true) {
        toast.success(
          response.data.reason || "Employees approved successfully",
          {
            className: "toast-success-custom",
          },
        );
      } else {
        toast.error(response.data.reason || "Failed to Approve Employee", {
          className: "toast-error-custom",
        });
      }
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Unable to connect to server",
      );
    }
  },
);

const approveExistingEmpSlice = createSlice({
  name: "existingEmployees",
  initialState: {
    approveExistingEmp: {},
    status: "idle",
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(approveExistingEmp.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(approveExistingEmp.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.approveExistingEmp = action.payload;
      })
      .addCase(approveExistingEmp.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default approveExistingEmpSlice.reducer;
